module.exports = __webpack_public_path__ + "img/belt_road.d71a34f5.jpg";